import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import Button from './Button';
import { CheckCircleIcon, ArrowLeftIcon, MailIcon } from 'lucide-react';
const PasswordResetSentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || 'your email';
  const [resendSuccess, setResendSuccess] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [cooldownTimer, setCooldownTimer] = useState(0);
  useEffect(() => {
    if (cooldownTimer > 0) {
      const timer = setTimeout(() => {
        setCooldownTimer(cooldownTimer - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldownTimer]);
  const handleResendEmail = () => {
    setResendLoading(true);
    setTimeout(() => {
      setResendLoading(false);
      setResendSuccess(true);
      setCooldownTimer(60);
      setTimeout(() => {
        setResendSuccess(false);
      }, 3000);
    }, 1500);
  };
  const handleBackToLogin = () => {
    navigate('/');
  };
  const isResendDisabled = resendLoading || cooldownTimer > 0;
  return <AuthLayout title="Check Your Email" data-id="element-131">
      <div className="text-center space-y-8 w-full" data-id="element-132">
        <div className="flex justify-center" data-id="element-133">
          <div className="bg-blue-100 p-5 rounded-full relative" data-id="element-134">
            <MailIcon size={50} className="text-blue-600" data-id="element-135" />
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-136">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-137">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-138"></path>
              </svg>
            </div>
          </div>
        </div>

        <div className="space-y-4" data-id="element-139">
          <h2 className="text-2xl font-semibold text-gray-800" data-id="element-140">
            Reset Instructions Sent
          </h2>

          <div className="bg-blue-50 p-5 rounded-xl border border-blue-200 shadow-sm" data-id="element-141">
            <p className="text-gray-600 mb-2" data-id="element-142">
              We've sent password reset instructions to:
            </p>
            <p className="font-medium text-blue-800 text-lg" data-id="element-143">{email}</p>
          </div>

          <p className="text-gray-600" data-id="element-144">
            Click the link in the email to reset your password. The link will
            expire in 24 hours.
          </p>
        </div>

        <div className="pt-4 space-y-5" data-id="element-145">
          {resendSuccess && <div className="flex items-center justify-center text-green-600 space-x-2 bg-green-50 p-3 rounded-lg animate-fade-in" data-id="element-146">
              <CheckCircleIcon size={20} data-id="element-147" />
              <span data-id="element-148">Email resent successfully</span>
            </div>}

          <div className="p-5 bg-blue-50 rounded-xl border border-blue-200 shadow-sm" data-id="element-149">
            <p className="text-gray-600 mb-3" data-id="element-150">Didn't receive the email?</p>
            <Button onClick={handleResendEmail} variant="outline" loading={resendLoading} disabled={isResendDisabled} fullWidth data-id="element-151">
              {cooldownTimer > 0 ? `Resend in ${cooldownTimer}s` : 'Resend reset instructions'}
            </Button>
          </div>

          <div className="pt-2" data-id="element-152">
            <button type="button" onClick={handleBackToLogin} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors" data-id="element-153">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-154" />
              Back to sign in
            </button>
          </div>
        </div>
      </div>
    </AuthLayout>;
};
export default PasswordResetSentPage;